import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';

export class VisitorTypeRelatedImageController extends AbstractStepController {

  onContextChange(contextChange: ContextChange) {

  }

  onRegisterToDashboardContext() {
    const visitorTypeId = this.dashboardContext.getContextValue('visitorType');
    const language = this.dashboardContext.getContextValue(TerminalContextConstants.language);
    const imageUrl = this.resolveImageForVisitorRole('' + visitorTypeId, '' + language);
    this.dashboardContext.setContextValue('visitorRoleRelatedImageUrl', imageUrl);
  }


  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('visitor type related image started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    const matDialog = WizardServiceLocator.injector.get(MatDialog);
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
      confirm: () => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    };
    matDialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    const nextControl = new StepControl();
    nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
    nextControl.type = StepControlType.BUTTON;
    nextControl.iconAfterCss = 'fa-thin fa-angle-right';
    nextControl.controlAction = () => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.next();
    };
    controls.push(nextControl);

    return controls;
  }



  private resolveImageForVisitorRole(visitorTypeId: string, language: string) {
    const config = this.wizardComponent.currentStep.dashboardConfiguration?.visitorTypeImageMapping;
    const imageUrl = (config[visitorTypeId] as string).replace('{visitorTypeId}', visitorTypeId).replace('{language}', language);
    return imageUrl;
  }

}
